import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { http } from '@/services/api'

interface OnboardingStatusResponse {
  steps: Array<{ id: string; completed: boolean }>
}

type WorkspaceDestination = '/app/query' | '/app/dashboard'

/**
 * Route a workspace to its real next moment.
 *
 * A workspace without an accepted Ask Ricald delegation starts with the task
 * surface. Returning workspaces continue in Today. Failure never traps an
 * authenticated customer in onboarding; Today remains the safe recovery path.
 */
export function WorkspaceEntryRoute() {
  const [destination, setDestination] = useState<WorkspaceDestination | null>(null)

  useEffect(() => {
    let active = true

    void http<OnboardingStatusResponse>('/onboarding/status')
      .then((status) => {
        if (!active) return
        const firstOperation = status.steps.find((step) => step.id === 'first_operation')
        setDestination(firstOperation?.completed === false ? '/app/query' : '/app/dashboard')
      })
      .catch(() => {
        if (active) setDestination('/app/dashboard')
      })

    return () => {
      active = false
    }
  }, [])

  if (!destination) {
    return (
      <div className="flex h-64 items-center justify-center" role="status">
        <span className="text-sm font-medium text-[var(--text-secondary)]">
          Opening your workspace…
        </span>
      </div>
    )
  }

  return <Navigate to={destination} replace />
}

export default WorkspaceEntryRoute
